<div class="alert alert-danger" *ngIf="player?.is_suspended == 1" role="alert">Account suspended. Agent actions are unavailable.</div>
<fieldset class="border-0 p-0 m-0 w-100" [disabled]="player?.is_suspended == 1" [attr.inert]="player?.is_suspended == 1 ? '' : null">
<div class="container">
    <div class="row">
        <div class="col-12 col-md-8">
            <h2>Player Rolling Game Rate</h2>

            <select>
                <option *ngFor="let label of labels" [value]="label.id">{{label.title}}</option>
            </select>
        
            <ng-container *ngIf="games && games.length > 0">
                <table class="table mt-3 table-sm table-striped">
                    <tbody>
                        <tr>
                            <td>Games</td>
                            <td>Referral/Upline Limit</td>
                            <td>Player Rate</td>
                        </tr>
                        <tr *ngFor="let game of games">
                            <td>{{game.title}}</td>
                            <td><span *ngIf="game.current_rate">{{game.current_rate}}</span>
                                <span *ngIf="!game.current_rate" >-</span>
                            </td>
                            <td>
                                <div class="input-group" *ngIf="game.current_rate">
                                    <input type="number" class="form-control" [(ngModel)]="game.percentage_to_next" name="percentage_to_next" >
                                    <div class="input-group-append">
                                      <span class="input-group-text">%</span>
                                    </div>
                                </div>
                                <span *ngIf="!game.current_rate" >-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="app-btn primary-btn btn-sm w-100" (click)="saveGameSetting()">Save</button>
            </ng-container>
        </div>
    </div>
</div>
</fieldset>
